
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/facilities/[id]/[bookingStep]",
      function () {
        return require("private-next-pages/spa/facilities/[id]/[bookingStep].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/facilities/[id]/[bookingStep]"])
      });
    }
  